// extracted by mini-css-extract-plugin
export default {"wrapper":"Oo-z","response":"Po-z","error":"Qo-z","disabled":"Ro-z","buttons":"So-z","feedbackQuestionSection":"To-z","yesNoWrapper":"Uo-z"};